// extracted by mini-css-extract-plugin
export default {"container":"GoalTargetType_container__G8r1+","switch":"GoalTargetType_switch__sEUti"};